<template>
    <table class="table is-fullwidth">
        <thead>
            <tr>
                <th>Name</th>
                <th>Location</th>
                <th>Role</th>
                <th>Team</th>
            </tr>
        </thead>
        <tbody v-for="volunteer in localVolunteers" :key="volunteer.id">
            <tr :class="[volunteer.volunteer_type == 'sponsor' ? 'green' : '']">
                <td>
                    <a @click="openPopup(volunteer.id)">{{ volunteer.name }}</a>
                </td>
                <td>{{ volunteer.location }}</td>
                <td>
                    <span v-if="volunteer.role == 'DRIVER'">Driver</span>
                    <span v-if="volunteer.role == 'OTHER'">Walking</span>
                    <span v-if="volunteer.with_helper"> + Helper</span>
                </td>
                <td>
                    <div class="select">
                        <select v-model="volunteer.team" @change="markDirty(volunteer.id)">
                            <option v-for="team in teams" :key="team">{{ team }}</option>
                        </select>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
    <div v-if="showPopup">
        <VolunteerModal @close-popup="closePopup" :userID="this.showPopupForVolunteer" :fdID="this.fdID"></VolunteerModal>
    </div>
    <div v-if="!!error" class="notification is-danger is-light">
        <p><b>Something went wrong!</b></p>
        <p>{{ error }}</p>
    </div>
    <div class="align-center field is-grouped">
        <p class="control">
            <button v-if="localVolunteers.length" :class="[isLoadingUpdate ? 'is-loading' : '']" class="button is-info is-rounded"
                @click="updateTeams">Update</button>
        </p>
    </div>
</template>

<script>
import VolunteerModal from './VolunteerModal.vue';

export default {
    components: {
        VolunteerModal
    },
    props: ["fdID", "drivingTeams", "walkingTeams"],
    data() {
        return {
            localVolunteers: [],
            dirtyIds: new Set(),
            isLoadingUpdate: false,
            error: null,
            showPopup: false,
            showPopupForVolunteer: null
        }
    },
    watch: {
        volunteers(incoming) {
            if (!incoming) return;
            const localMap = new Map(this.localVolunteers.map(v => [v.id, v]));
            this.localVolunteers = incoming.map(v => {
                const existing = localMap.get(v.id);
                if (existing && this.dirtyIds.has(v.id)) {
                    // Preserve the admin's unsaved team selection; update everything else
                    return { ...v, team: existing.team };
                }
                return { ...v };
            });
        }
    },
    methods: {
        markDirty(volunteerId) {
            this.dirtyIds.add(volunteerId);
        },
        async updateTeams() {
            this.isLoadingUpdate = true;
            try {
                await this.$store.dispatch('volunteer/updateTeams', {
                    fdID: this.fdID,
                    volunteers: this.localVolunteers
                });
                this.dirtyIds.clear();
            } catch (error) {
                console.log(error);
                this.error = error;
            }
            this.isLoadingUpdate = false;
        },
        openPopup(vid) {
            this.showPopupForVolunteer = vid;
            this.showPopup = true;
        },
        closePopup() {
            this.showPopup = false;
        }
    },
    computed: {
        volunteers() {
            return this.$store.getters["volunteer/getVolunteers"];
        },
        teams() {
            const teamNames = [];
            for (let i = 1; i <= this.drivingTeams; i++) {
                teamNames.push("driving" + i);
            }
            for (let i = 1; i <= this.walkingTeams; i++) {
                teamNames.push("walking" + i);
            }
            teamNames.push("void_deck");
            return teamNames;
        }
    },
    mounted() {
        this.$store.dispatch('volunteer/subscribeVolunteers', this.fdID);
    },
    unmounted() {
        this.$store.dispatch('volunteer/unsubscribeVolunteers');
    }
}
</script>

<style scoped>
.align-center {
    justify-content: center;
}
</style>
